import {
  createStyles,
  Menu,
  Center,
  Header,
  Container,
  Group,
  Button,
  Burger,
  Transition,
  Paper,
  rem,
} from '@mantine/core';
import {Link} from 'react-router-dom';
import {useDisclosure} from '@mantine/hooks';
import {IconChevronDown, IconArrowRight} from '@tabler/icons-react';
import logo from '../../../assets/img/lo-go3.png';

const HEADER_HEIGHT = rem(100);

const useStyles = createStyles(theme => ({
  root: {
    position: 'relative',
    backgroundColor: '#F2F6F7',
    zIndex: 1,
  },
  inner: {
    height: HEADER_HEIGHT,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  links: {
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },
  dropdown: {
    position: 'absolute',
    top: HEADER_HEIGHT,
    left: 0,
    right: 0,
    zIndex: 0,

    padding: rem(5),
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    borderTopWidth: 0,
    overflow: 'hidden',

    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
  },

  burger: {
    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
  },

  link: {
    display: 'block',
    lineHeight: 1,
    padding: `${rem(8)} ${rem(12)}`,
    borderRadius: theme.radius.sm,
    textDecoration: 'none',
    color: '#21485e',
    fontSize: theme.fontSizes.sm,
    fontWeight: 600,

    '&:hover': {
      backgroundColor:
        theme.colorScheme === 'dark'
          ? theme.colors.dark[6]
          : theme.colors.gray[0],
    },
  },

  linkLabel: {
    marginRight: rem(5),
    color: '#21485e',
  },
}));

interface HeaderActionProps {
  links: {
    link: string;
    label: string;
    links?: {link: string; label: string}[];
  }[];
}

export function Navbar({links}: HeaderActionProps) {
  const {classes} = useStyles();
  const [opened, {toggle}] = useDisclosure(false);

  const items = links.map(link => {
    const menuItems = link.links?.map(item => (
      <Menu.Item key={item.link} component="a" href={item.link} color="#21485e">
        {item.label}
      </Menu.Item>
    ));

    if (menuItems) {
      return (
        <Menu
          key={link.label}
          trigger="click"
          transitionProps={{exitDuration: 0}}
          withinPortal
        >
          <Menu.Target>
            <span className={classes.link}>
              <Center>
                <span className={classes.linkLabel}>{link.label}</span>
                <IconChevronDown size={rem(12)} stroke={1.5} />
              </Center>
            </span>
          </Menu.Target>
          <Menu.Dropdown>{menuItems}</Menu.Dropdown>
        </Menu>
      );
    }

    return (
      <a key={link.label} href={link.link} className={classes.link}>
        {link.label}
      </a>
    );
  });

  return (
    <Header
      height={HEADER_HEIGHT}
      sx={{borderBottom: 0}}
      mb={!opened ? 0 : 120}
      className={classes.root}
    >
      <Container className={classes.inner} fluid>
        <Burger
          opened={opened}
          onClick={toggle}
          className={classes.burger}
          size="sm"
        />
        <Link to="/">
          <img src={logo} alt="Logo" />
        </Link>
        <Group spacing={5} className={classes.links}>
          {items}
        </Group>

        <Transition transition="slide-left" duration={200} mounted={opened}>
          {styles => (
            <Paper className={classes.dropdown} withBorder style={styles}>
              {items}
            </Paper>
          )}
        </Transition>
        <Group>
          <Button
            //onClick={open}
            leftIcon={<IconArrowRight size={rem(18)} />}
            styles={theme => ({
              root: {
                backgroundColor: '#485e21',
                border: 0,

                '&:not([data-disabled])': theme.fn.hover({
                  backgroundColor: '#21485e',
                  color: '#ffffff',
                }),
              },

              leftIcon: {
                marginRight: theme.spacing.md,
              },
            })}
          >
            Logout
          </Button>
        </Group>
      </Container>
    </Header>
  );
}
